/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import PaymentChannels from '../channels/PaymentChannels';

const PlanCard = ({
  planName,
  cost,
  bonus,
  amount,
  image,
  checked,
  onChange,
  interval,
  paystackPlanCode,
  ravePlanCode,
}) => {
  return (
    <div className="col-xl-5 col-md-6 mb-4">
      <div className="card box shadow h-100 py-2">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col mr-2">
              <div className="d-flex mb-2">
                <div>
                  <img src={image} alt="House" className="mr-2 mt-4" />
                </div>
                <div className="mb-3">
                  <p className="font_18 text-nowrap letter_spacing bolder_font margin_bottom">
                    {planName}
                  </p>
                  <p className="font_14 lighter_font mb-0 pb-0">
                    <span className="m-0 p-0">
                      GH₵
                      {cost}
                    </span>
                    <br />
                    <span className="bonus m-0 p-0">{bonus}</span>
                  </p>
                  <div className="custom-control custom-checkbox">
                    <label className="checkbox-inline d-flex lighter_font text-nowrap">
                      <input
                        type="checkbox"
                        className="mt-1 custom-control-input"
                        checked={checked}
                        onChange={onChange}
                      />
                      <span className="custom-control-label">
                        I want to be charged
                        {interval}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <PaymentChannels
                paystackPlanCode={paystackPlanCode}
                ravePlanCode={ravePlanCode}
                checked={checked}
                amount={amount}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PlanCard.propTypes = {
  planName: PropTypes.string.isRequired,
  bonus: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  interval: PropTypes.string.isRequired,
  paystackPlanCode: PropTypes.string.isRequired,
  ravePlanCode: PropTypes.string.isRequired,
};

export default PlanCard;
